<template>
  <div class="info_list">
    <div class="left_title">
      {{ goodsData.goodsName }}
    </div>
    <div class="left">
      <div class="left_content_list">
        <div class="pic">
          <img :src="goodsData.goodsImage" alt="" />
        </div>
        <div class="text_list">
          <div class="price">
            ￥{{ goodsData.skuAmount }}.<span class="z">00</span>
          </div>
          <div class="text_title">红色款【非祖国果冻唇】；盲盒随机发不指定</div>
          <div class="text_count">数量：{{ goodsData.quantity }}</div>
          <!-- <div class="count">
            <div class="left1" @click="handleCount('reduce', 1)">-</div>
            <div class="mid">{{ 1 }}</div>
            <div class="right1" @click="handleCount('add', 1)">+</div>
          </div> -->
        </div>
      </div>
      <div class="mid">
        <div class="mid_title">配送服务</div>
        <div class="mid_content">
          <div class="goodsData">￥{{ goodsData.logisticsAmount }}.00</div>
          <!-- <div class="goodsData">快递</div>
          <div class="goodsData">免邮</div>
          <div class="goodsData">送运费险</div> -->
        </div>
        <div class="mid_title">订单备注</div>
        <div class="mid_item">无备注</div>
      </div>
      <!-- <div class="right">
        <div class="right_title">优惠</div>
        <div class="right_item">全场8折</div>
      </div> -->
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps } from "vue";
const props = defineProps(["goodsData"]);
const goodsData = ref(props.goodsData);
console.log("goodsData", goodsData.value);
// const emit = defineEmits(["getSelectAddress"]);
</script>
<style scoped lang="scss">
.info_list {
  display: flex;
  flex-direction: column;
  width: 1121px;
  background: var(--ux-card-bg);
  border-radius: 20px;
  padding: 25px 35px;
  .left_title {
    color: var(--ux-text-primary);
    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: 350;
    line-height: 23.4px;
    margin-bottom: 15px;
  }
  .left {
    display: flex;

    .left_content_list {
      display: flex;
      .pic {
        width: 142px;
        height: 142px;
        padding: 20px;
        background-color: var(--ux-glass-bg-subtle);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text_list {
        margin-left: 7px;
        .price {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 700;
          .z {
            font-weight: 700;
            font-size: 18px;
          }
        }
        .text_title {
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 350;
          color: #3d3d3d;
          opacity: 0.5;
          margin-top: 13px;
          width: 240px;
        }
        .text_count {
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 350;
          color: #3d3d3d;
          opacity: 0.5;
          margin-top: 28px;
        }
      }
    }
  }
  .mid {
    margin-left: 140px;
    .mid_title {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      margin-bottom: 8px;
    }
    .mid_content {
      display: flex;
      margin-bottom: 8px;
      .goodsData {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        color: var(--ux-text-primary);
        opacity: 0.5;
      }
    }
    .mid_item {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      opacity: 0.5;
      margin-bottom: 8px;
    }
  }
  .right {
    margin-left: 70px;
    .right_title {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      margin-bottom: 8px;
    }
    .right_item {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      opacity: 0.5;
      margin-bottom: 8px;
    }
  }
}
</style>
